import React from 'react';
import { ArticlePartnerOffers } from '../../components/partners/ArticlePartnerOffers';
import { ArticleJsonLd } from '../../components/seo/SchemaMarkup';
import { RelatedArticles } from '../../components/articles/RelatedArticles';
import { AIRecommendations } from '../../components/articles/AIRecommendations';
import { SeriesNavigation } from '../../components/articles/SeriesNavigation';
import { CUSTOM_ARTICLES, PeptiqInlineCTA } from './customArticleMap';
import AprProductGrid from '../../components/apr/AprProductGrid';
import { EvidenceOrganizations } from '../../components/articles/ArticleSEOComponents';

/**
 * Renders any of the bespoke interactive articles registered in
 * `CUSTOM_ARTICLES`. Looks up by slug; caller already verified the slug is
 * present via `hasCustomLayout()`.
 */
export const CustomArticleView = ({ slug, article }) => {
  const config = CUSTOM_ARTICLES[slug];
  if (!config) return null;
  const { Component, withPeptiqCta, props: componentProps } = config;

  return (
    <main className="pt-20 min-h-screen" data-testid="article-page">
      <ArticleJsonLd article={article} slug={slug} />
      <Component {...(componentProps || {})} />
      <div className="max-w-3xl mx-auto px-6 pb-16">
        {article.category === 'Peptides' && (
          <AprProductGrid matchText={`${article.title || ''} ${slug || ''} ${(article.tags || []).join(' ')}`} />
        )}
        {withPeptiqCta && <PeptiqInlineCTA />}
        <ArticlePartnerOffers article={article} placement="article-end"/>
        <EvidenceOrganizations sources={article.evidence_sources} />
        <SeriesNavigation currentSlug={slug} />
        <AIRecommendations currentSlug={slug} category={article.category} />
        <RelatedArticles currentSlug={slug} category={article.category} internalLinks={article.internal_links} />
      </div>
    </main>
  );
};
